
@if (this.loadingMetadata()) {
    <div class="flex justify-center p-8">
        <p-progressSpinner ariaLabel="loading" />
    </div>
} @else if (measurement(); as m) {
  <cosmos-measurement-info-card
    [measurement]="m"
    [device]="device()"
    [cardSubtitle]="('measurement.types.StructuralHealthMeasurement' | translate) + ' - ' + ((m.active ? 'measurement.ongoing' : 'measurement.finished') | translate)"
  >
    <ng-container cardFooter>
      <p-confirmdialog />
      <div class="flex flex-wrap gap-2 items-center">
        @if (rbac.canEditProject()) {
          <p-button (click)="editMeasurement()" color="primary" [disabled]="loadingData()"><i class="fa-solid fa-edit"></i> {{ "measurement.edit" | translate }}</p-button>
        }
        @if (m.active && rbac.canEditProject()) {
          <p-button (click)="finishMeasurement($event)" severity="danger" [disabled]="loadingData()"><i class="fa-solid fa-link-slash"></i>{{ "measurement.finish" | translate }}</p-button>
        }
        @if (rbac.canEditProject()) {
          <cosmos-measurement-actions-menu [actions]="tier2Actions()" />
        }
      </div>
    </ng-container>
  </cosmos-measurement-info-card>
}

@if (this.loadingData()) {
    <p-divider></p-divider>
    <div class="flex flex-col items-center justify-center p-12">
        <p-progressSpinner ariaLabel="loading" />
        <span class="mt-4 text-gray-500">{{ 'measurement.shm.loadingData' | translate }}</span>
    </div>
} @else {
    @if (corrosionData().length > 0) {
        <p-divider></p-divider>
        <h3>{{ 'measurement.shm.channelTypes.corrosion' | translate }}</h3>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            @for (variable of corrosionVariables; track variable) {
                <p-card class="min-w-0">
                    <ng-template #title>{{ 'measurement.shm.variables.' + variable | translate }}</ng-template>
                    <div class="flex w-full min-w-0">
                        <cosmos-multi-line-chart
                            [dataObjects]="corrosionData()"
                            [dataset]="variable"
                            [chartId]="'shm_' + variable"
                            [downloadAllowed]="true"
                            [rangeSelector]="true"
                            [selectedRange]="corrosionRange()"
                            [thresholdBands]="thresholdBandsFor(variable)"
                            (rangeChange)="onCorrosionRangeChange($event)"
                            (datapointClick)="onDatapointClick($event, 'corrosion')">
                        </cosmos-multi-line-chart>
                    </div>
                </p-card>
            }
        </div>
    }

    @if (phData().length > 0) {
        <p-divider></p-divider>
        <h3>{{ 'measurement.shm.channelTypes.ph' | translate }}</h3>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            @for (variable of phVariables; track variable) {
                <p-card class="min-w-0">
                    <ng-template #title>{{ 'measurement.shm.variables.' + variable | translate }}</ng-template>
                    <div class="flex w-full min-w-0">
                        <cosmos-multi-line-chart
                            [dataObjects]="phData()"
                            [dataset]="variable"
                            [chartId]="'shm_' + variable"
                            [downloadAllowed]="true"
                            [rangeSelector]="true"
                            [selectedRange]="phRange()"
                            (rangeChange)="onPhRangeChange($event)"
                            (datapointClick)="onDatapointClick($event, 'ph')">
                        </cosmos-multi-line-chart>
                    </div>
                </p-card>
            }
        </div>
    }

    @if (chloridesData().length > 0) {
        <p-divider></p-divider>
        <h3>{{ 'measurement.shm.channelTypes.chlorides' | translate }}</h3>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            @for (variable of chloridesVariables; track variable) {
                <p-card class="min-w-0">
                    <ng-template #title>{{ 'measurement.shm.variables.' + variable | translate }}</ng-template>
                    <div class="flex w-full min-w-0">
                        <cosmos-multi-line-chart
                            [dataObjects]="chloridesData()"
                            [dataset]="variable"
                            [chartId]="'shm_' + variable"
                            [downloadAllowed]="true"
                            [rangeSelector]="true"
                            [selectedRange]="chloridesRange()"
                            (rangeChange)="onChloridesRangeChange($event)"
                            (datapointClick)="onDatapointClick($event, 'chlorides')">
                        </cosmos-multi-line-chart>
                    </div>
                </p-card>
            }
        </div>
    }

    @if (temperatureData().length > 0) {
        <p-divider></p-divider>
        <h3>{{ 'measurement.shm.channelTypes.temperature' | translate }}</h3>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            @for (variable of temperatureVariables; track variable) {
                <p-card class="min-w-0">
                    <ng-template #title>{{ 'measurement.shm.variables.' + variable | translate }}</ng-template>
                    <!-- datapoint panel not wired for temperature yet — SHMDatapointAdapter's
                         channelType only covers corrosion/ph/chlorides -->
                    <div class="flex w-full min-w-0">
                        <cosmos-multi-line-chart
                            [dataObjects]="temperatureData()"
                            [dataset]="variable"
                            [chartId]="'shm_' + variable"
                            [downloadAllowed]="true"
                            [rangeSelector]="true"
                            [selectedRange]="temperatureRange()"
                            (rangeChange)="onTemperatureRangeChange($event)">
                        </cosmos-multi-line-chart>
                    </div>
                </p-card>
            }
        </div>
    }

    @if (!this.loadingData() && corrosionData().length === 0 && phData().length === 0 && chloridesData().length === 0 && temperatureData().length === 0) {
        <p-divider></p-divider>
        <p-card>
            <div class="text-center p-4">{{ 'measurement.shm.noData' | translate }}</div>
        </p-card>
    }
}
